import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';

import store from 'store';

import 'react-toastify/dist/ReactToastify.css';
// This import should occur before routes import for correct styling
import './index.scss';

import AppRoutes from 'routes';

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  </Provider>,
  document.getElementById('root'),
);
